/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'agent/determination': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 6a4 4 0 100 8 4 4 0 000-8zm0 7.5v-7c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5z"/><path pid="1" d="M10 2c-4.417 0-8 3.583-8 8s3.583 8 8 8 8-3.583 8-8-3.583-8-8-8zm0 15c-3.86 0-7-3.141-7-7 0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7 0 3.859-3.141 7-7 7z"/>'
  }
})
